import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import closeIco from 'assets/images/close-btn-violet.svg';
import ELID from 'constants/elid.const';
import { formatLocalizedTime } from 'utils/date/format.util';

import { cleanBookingData } from 'booking/actions';

class CloseButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpened: false,
    };
  }

  onYesBtn = () => {
    this.setState({ dialogOpened: false });
  };

  onNoBtn = () => {
    const { addedServices, cleanBookingData, close, saveBooking, history } = this.props;
    let stylistTimeNotSet = false;
    // if service not added yet, close, otherwise show popup
    if (close && history.location.pathname.indexOf('services') < 0) {
      history.push(close);
    } else if (addedServices && addedServices.length === 0) {
      history.push(close);
    } else if (addedServices && addedServices.length > 0) {
      const { addedServices } = this.props;
      if (addedServices.length > 0) {
        for (let i = 0; i < addedServices.length; i += 1) {
          const service = addedServices[i];
          if (!service.stylist_id) {
            stylistTimeNotSet = true;
            break;
          }
          const str = formatLocalizedTime(service.start_time);
          if (str === '12:00 AM' || parseInt(str.split(' ')[0].split(':')[1], 10) % 15 !== 0 || !service.stylist_id) {
            stylistTimeNotSet = true;
            break;
          }
        }
      }
    }
    if (saveBooking) {
      saveBooking();
    }
    if (cleanBookingData && !stylistTimeNotSet) {
      cleanBookingData();
    }
  };

  setOneOrAll = (p) => {
    const { setOneOrAll } = this.props;
    if (setOneOrAll) {
      this.setState({ dialogOpened: false });
      setOneOrAll(p);
    }

    const parentEl = document.querySelector(`#${ELID.schedscroll}`);
    const childEl = document.querySelector(`#${ELID.closepop}`);
    if (parentEl && childEl) {
      parentEl.removeChild(childEl);
    }
  };

  render() {
    const { disableConfirm, setOneOrAll } = this.props;
    const { dialogOpened } = this.state;
    window.setOneOrAll = this.setOneOrAll;
    const parentEl = document.getElementById(ELID.schedscroll);
    let popupEl = document.getElementById(ELID.closepop);
    if (!popupEl) {
      popupEl = document.createElement('div');
      popupEl.id = ELID.closepop;
      let parentNode;
      popupEl.innerHTML = `<div class="overlay" />
      <div class="confirmation-modal animated zoomIn">
        <div class="modal-body">
          <h2 class="modal-title">Repeating booking</h2>
          <div class="modal-content">This is a repeating booking.
          Your edit will only be applied to the current booking.</div>
          <div class="modal-footer">
            <button class="btn btn-violet-link" onclick="window.setOneOrAll('one')" >OKAY</button>
          </div>
        </div>
      </div>`;
      if (parentEl && dialogOpened && typeof setOneOrAll === 'function') {
        parentEl.appendChild(popupEl);
        parentNode = popupEl.parentElement;
      } else if (parentNode && !dialogOpened) {
        parentNode.removeChild(popupEl);
      }
    }

    return (
      <div className="">
        <div
          onClick={() => {
            if (disableConfirm) {
              this.onNoBtn();
            } else {
              this.setState({ dialogOpened: true });
            }
          }}
          className="close-ico"
          role="button"
          tabIndex={0}
        >
          <img src={closeIco} alt="" />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({ cleanBookingData }, dispatch);

export default connect(null, mapDispatchToProps)(CloseButton);
